import { home } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import { SettingsCardData } from '../../types/settingsCardData'
import ProfileInformationCard from '../components/ProfileInformationCard'

const MeteringPointSettings = () => {
	const { t } = useTranslation('pages_settings', { keyPrefix: 'meteringPointInformation' })

	const cards: SettingsCardData[] = [
		{
			label: t('meteringPointBasics'),
			icon: home,
			page: 'settings/metering-point/information',
		},
	]

	return (
		<PageWrapper page='meteringPointInformation' appBarOptions={{ backPath: '/settings' }}>
			<div className='flex flex-col gap-4'>
				{cards.map(cardProps => (
					<ProfileInformationCard
						key={cardProps.label}
						icon={cardProps.icon}
						label={cardProps.label}
						modal={cardProps.modal}
						page={cardProps.page}
					/>
				))}
			</div>
		</PageWrapper>
	)
}

export default MeteringPointSettings
